Object.defineProperty(exports,"__esModule",{value:true});exports.getAttachmentDownloadUrl=exports.getAttachmentType=exports.attachmentTypes=undefined;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[typeof Symbol==='function'?Symbol.iterator:'@@iterator'](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if((typeof Symbol==='function'?Symbol.iterator:'@@iterator')in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _urijs=require('urijs');var _urijs2=_interopRequireDefault(_urijs);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}

var attachmentTypes=exports.attachmentTypes={
IMAGE:'image',
PPT:'ppt',
UNKNOWN:'unknown',
XLS:'xls',
DOC:'doc',
PDF:'pdf',
CSV:'csv',
SVG:'svg'};


var microsoftSubtypes=[
'vnd.ms-powerpoint',
'vnd.openxmlformats-officedocument.presentationml',
'vnd.ms-excel',
'vnd.openxmlformats-officedocument.spreadsheetml',
'vnd.ms-word',
'vnd.openxmlformats-officedocument.wordprocessingml'];


var stripMicrosoftSubtype=function stripMicrosoftSubtype(originalMime){var _originalMime$split=
originalMime.split('/'),_originalMime$split2=_slicedToArray(_originalMime$split,2),mimeType=_originalMime$split2[0],mimeSubtype=_originalMime$split2[1];
var microsoftSubtypeRegex=new RegExp(microsoftSubtypes.map(function(subtype){return subtype.replace('.','\\.');}).join('|'));
var res=microsoftSubtypeRegex.exec(mimeSubtype);
return res?mimeType+'/'+res:originalMime;
};

var stripImageSubtype=function stripImageSubtype(originalMime){var _originalMime$split3=
originalMime.split('/'),_originalMime$split4=_slicedToArray(_originalMime$split3,2),mimeType=_originalMime$split4[0],mimeSubtype=_originalMime$split4[1];
return mimeSubtype==='svg+xml'||mimeType!=='image'?originalMime:'image';
};

var stripSubtype=function stripSubtype(originalMime){
var stripedMicrosoftType=stripMicrosoftSubtype(originalMime);
return stripImageSubtype(stripedMicrosoftType);
};

var getAttachmentType=exports.getAttachmentType=function getAttachmentType(contentType){
switch(stripSubtype(contentType)){
case'text/csv':
return attachmentTypes.CSV;
case'image':
return attachmentTypes.IMAGE;
case'image/svg+xml':
return attachmentTypes.SVG;
case'application/msword':
case'application/vnd.ms-word':
case'application/vnd.openxmlformats-officedocument.wordprocessingml':
return attachmentTypes.DOC;
case'application/excel':
case'application/vnd.ms-excel':
case'application/vnd.openxmlformats-officedocument.spreadsheetml':
return attachmentTypes.XLS;
case'application/pdf':
return attachmentTypes.PDF;
case'application/vnd.ms-powerpoint':
case'application/vnd.openxmlformats-officedocument.presentationml':
return attachmentTypes.PPT;
default:
return attachmentTypes.UNKNOWN;}

};

var getAttachmentDownloadUrl=exports.getAttachmentDownloadUrl=function getAttachmentDownloadUrl(_ref){var filename=_ref.filename,url=_ref.url;
var cloudPlatformAttachmentParam='response-content-disposition';
var cloudPlatformAttachmentParamValue='attachment;filename="'+filename+'"';
return new _urijs2.default(url).addSearch(cloudPlatformAttachmentParam,cloudPlatformAttachmentParamValue).toString();
};


//////////////////
// WEBPACK FOOTER
// ../~/inbox-common/dist/attachments.js
// module id = 784
// module chunks = 0